import { Component } from '@angular/core';
import {ViewController } from 'ionic-angular';
import { AppData } from '../../providers/app-data';
import { IdentifyData } from '../../providers/identify-data';
import { MapData } from '../../providers/map-data';
import { SavedLocation } from '../../classes/SavedLocation';
import { StorageService } from '../../services/storage-service';

@Component({
    selector: 'identify',
    templateUrl: 'identify.html'
})

export class IdentifyPage {
    hasLatLong: boolean = false;
    saved: boolean = false;
    private storageKey: string = this.appData.settings.locationStorageKey;
    private storageHelper: StorageService = new StorageService();

    constructor(public appData: AppData, public identifyData: IdentifyData, public mapData: MapData, public viewCtrl: ViewController) {
        this.checkIfHasLatLong();
    }

    swipe(e) {
        if (this.identifyData.selectedFeatures.length > 0) {
            var newIndex = this.identifyData.selectedIndex;
            if (e.direction === 4 || e.direction === 1) {
                // check if it's the first feature. if so, a "back swipe" should navigate to last feature. 
                // previously a back swipe would alternate between 1st and 2nd feature.
                if(newIndex !== 0)
                    newIndex--;
                else {
                    newIndex = this.identifyData.selectedFeatures.length - 1;
                }
            } else if (e.direction ===2) {
                newIndex++;
            }
            newIndex = Math.abs(newIndex % this.identifyData.selectedFeatures.length);
            this.activateIndex(newIndex);
        }
    }
    // #10761 click to change feature. clickNext to show next feature and clickPrevious to show previous feature
    clickNext(e){
        if (this.identifyData.selectedFeatures.length > 0) {
            var newIndex = this.identifyData.selectedIndex;
            newIndex++;
            newIndex = Math.abs(newIndex % this.identifyData.selectedFeatures.length);
            this.activateIndex(newIndex);
        }
    }
    clickPrevious(e){
        if (this.identifyData.selectedFeatures.length > 0) {
            var newIndex = this.identifyData.selectedIndex;
            if(newIndex !== 0){
                newIndex--;
                newIndex = Math.abs(newIndex % this.identifyData.selectedFeatures.length);
            } else {
                newIndex = this.identifyData.selectedFeatures.length - 1; // navigate to last index
            }
            this.activateIndex(newIndex);
        }
    }

    checkIfHasLatLong() {
        if (!this.appData || !this.appData.selectedFeature) {
            return;
        }
        let attr = this.appData.selectedFeature.attributes
        if (!attr) {
            return;
        }
        let hasLat = false;
        let hasLon = false;

        //go over all the attributes for this feature to check if it does have lat/long in its data for saving
        for (let item of attr) {
            if (item.alias === 'Latitude') {
                hasLat = true;      
            } else if (item.alias === 'Longitude') {
                hasLon = true;
            }
        }
        if (hasLat && hasLon) {
            this.hasLatLong = true;
        } else { 
            this.hasLatLong = false;
        }
    }

    activateIndex(newIndex) {
        this.identifyData.selectFeatureByIndex(newIndex);
        this.mapData.showFeaturesOnMap();
        this.checkIfHasLatLong();
    }

    saveLocation() {
        let locationToSave = new SavedLocation(this.appData.selectedFeature.layerTitle, 0, 0);
        //go over the attributes to try and extract useful data (lat/long and label info)
        if (!this.appData || !this.appData.selectedFeature && !this.appData.selectedFeature.attributes) {
            return;
        }
        let attr = this.appData.selectedFeature.attributes;
        for (let item of attr) {
            switch (item.alias) {
                case 'Latitude':
                    locationToSave.lat = item.value;
                    break;
                case 'Longitude':
                    locationToSave.lon = item.value;
                    break;
                case 'Site Number':
                    locationToSave.displayName += ' ' + item.value;
                    break;
            }
        }
        this.storageHelper.appendToArray(this.storageKey, [], locationToSave);
        this.saved = true;
    }

    dismiss() {
        this.mapData.dismissIdentify();
    }

}


// WEBPACK FOOTER //
// ./src/pages/identify/identify.ts